import { Box, Typography } from '@mui/material';
import {
  Control,
  Controller,
  FieldError,
  FieldValues,
  Path,
} from 'react-hook-form';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateRangeIcon from '../Icons/DateRangeIcon';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface DateInputProps<T extends FieldValues> {
  control: Control<T, any>;
  name: Path<T>;
  label?: string;
  error?: FieldError;
  helperText?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const DateInputISO = <T extends FieldValues>({
  control,
  name,
  label,
  error,
  helperText,
  placeholder = 'DD.MM.YYYY',
  onChange,
  disabled,
}: DateInputProps<T>) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" flexDirection="column" gap="12px" width="100%">
        <Typography variant="caption" padding={'0 4px'} color={'text.primary'}>
          {label}
        </Typography>
        <Box
          display="flex"
          width="100%"
          sx={{
            position: 'relative',
          }}
        >
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <DatePicker
                format="DD.MM.YYYY"
                value={field.value ? dayjs(field.value) : null}
                inputRef={field.ref}
                sx={{ width: '100%' }}
                onChange={date => {
                  if (date && date.isValid()) {
                    const isoDate = date.toISOString();
                    field.onChange(isoDate);
                    if (onChange) {
                      onChange(isoDate);
                    }
                  } else {
                    field.onChange(null);
                  }
                }}
                slots={{
                  openPickerIcon: DateRangeIcon,
                }}
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    helperText: helperText || '',
                    error: !!error,
                    placeholder: placeholder,
                    disabled: disabled,
                    InputLabelProps: {
                      shrink: true,
                    },
                  },
                }}
                disabled={disabled}
              />
            )}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateInputISO;
